<template>
  <myhead @next="apply">{{ $route.query.title || $route.meta.title}}</myhead>
  <div class="pad15">
    <p class="mb10 b500">请真实选择以下观念：</p>
    <div class="BGf0 pad10 radius8 mb10" v-for="item,index in list" :key="index">
      {{item.name}}
      <div class="flex right">
        <van-space size="15px" v-if="item.answer==null">
          <van-button round @click="item.answer=0">拒接</van-button>
          <van-button round type="primary" @click="item.answer=1">接受</van-button>
        </van-space>
        <div v-else class="mr10 mb5 Con size14">
          {{item.answer==0?'拒绝':'接受'}}
        </div>
      </div>
    </div>
    <van-popup v-model:show="p1" :style="{padding:'20px'}">
      <img src="@/assets/img/p1.png" style="display:block;margin:0 auto;max-width: 100%" />
    </van-popup>
    <van-popup v-model:show="p2" :style="{padding:'20px'}">
      <img src="@/assets/img/p2.png" style="display:block;margin:0 auto;max-width: 100%" />
    </van-popup>
    <van-popup v-model:show="p3" :style="{ padding:'20px'}">
      <img src="@/assets/img/p3.png" style="display:block;margin:0 auto;max-width: 100%" />

    </van-popup>
    <van-popup v-model:show="p4" :style="{padding:'20px'}">
      <img src="@/assets/img/p4.png" style="display:block;margin:0 auto;max-width: 100%" />
    </van-popup>
    <div class="height200px"></div>

    <div class="fixed l r b pad14 mb10 center explain_bottom">
      <div class="explain">
        <div v-if="pageType == 'register'" class="explain_item" @click="p1 = !p1">1.注册预算</div>
        <div v-if="pageType == 'register'" class="explain_item" @click="p2 = !p2">2.《TTC-商道新风》</div>
        <div v-if="pageType == 'register'" class="explain_item" @click="p3 = !p3">3.股权待遇</div>
        <div v-if="pageType == 'register'" class="explain_item" @click="$router.push({path:'/vote',query:{active:0}})">4.《TTC-司法体制》</div>
        <div v-if="pageType == 'register'" class="explain_item" @click="$router.push({path:'/money',query:{active:1}})">5.财政基金板块</div>

        <div v-if="pageType == 'shop'" @click="p4 =!p4" class="explain_item">1.成本价乘共和系数</div>
        <div v-if="pageType == 'shop'" @click="p3 = !p3" class="explain_item">2.股权待遇</div>
        <div v-if="pageType == 'shop'" @click="$router.push({path:'/join',query:{active:0}})" class="explain_item">3.产品加盟</div>
        <div v-if="pageType == 'shop'" @click="$router.push({path:'/join',query:{active:1}})" class="explain_item">4.人才加盟</div>

      </div>
      <van-button block round type="primary" @click="apply">提交</van-button>
    </div>
  </div>
  <!-- <van-popup
    v-model:show="playAlery"
    position="bottom"
    :closeable="true"
    class="center vh30 pad25 size16 b500"
  >
    <div>
      {{ pageType == 'recruit' ? '应聘匹配': pageType == 'procure' ? '采购匹配': '成员注册支付'}}
    </div>
    <div class="Cred size24 pad20"> <span class="size12">￥</span>{{amount}}</div>
    <van-radio-group class="payBox" v-model="typeid">
        <van-radio name="2" label-position="left"><img src="@/assets/img/pay-wx.png" alt="">
          <span class="inlnie " style="">微信支付</span>
        </van-radio>
        <van-radio name="1" label-position="left"><img src="@/assets/img/pay-aliay.png" alt=""><span class="inlnie">支付宝支付</span></van-radio>
      </van-radio-group>
      <van-button block round type="primary" class="mt90" @click="apply">提交</van-button>
  </van-popup> -->
  <PayDialog v-model:showPopup="playAlery"
    :title="pageType == 'recruit' ? '应聘匹配': pageType == 'procure' ? '采购匹配': pageType == 'procure'?'商城购买':'成员注册支付'" :amount="amount" :nextFn="apply">
  </PayDialog>

</template>

<script>
import PayDialog from "@/components/PayDialog.vue";
export default {
  components: { PayDialog },
  name: 'Sense',
  data () {
    return {
      p1: false,// 图1
      p2: false,// 图2
      p3: false,// 图3
      p4: false,// 图4

      typeid: '1',
      pageType: 'register',
      playAlery: false,
      list: [], cate_id: null,
      no: '', amount: ''
    }
  },
  methods: {
    apply (amount, typeid) {
      // console.log(amount, typeid);
      let return_url = '/#/' + this.pageType
      let query = {}
      if (this.pageType == 'register') {
        return_url = location.origin + return_url + '?loginStatus=2'
        query = { ...this.$router.query, loginStatus: 2 }
      }
      if (this.playAlery) {
        this.ajax({
          method: "post", url: "pay/pay", data: {
            typeid, no: this.no, return_url
          }, myData: { showMsg: false }
        })
          .then(res => {
            if (typeid == 1) {
              location.href = res.data.info;

            } else {
              //开发中
            }
          })
          .catch(({ message }) => {
            if (amount == 0) {
              return this.$router.push({ path: '/' + this.pageType, query })
            } else {
              this.showNotify({ message })
            }
          })
        return
      }
      let { column_type } = this.$route.query;
      let params = {
        cate_id: this.cate_id || '',
        concept: JSON.stringify(this.list)
      }
      if (column_type) {
        params.column_type = column_type;
      }
      this.ajax({
        method: 'post',
        url: this.pageType == 'shop' ? 'products/checkconcept' : this.pageType == 'procure' ? 'procures/checkconcept' : this.pageType == 'recruit' ? "recruits/checkconcept" : this.pageType == 'join' ? 'joins/checkconcept' : "users/checkconcept",
        data: params,
        myData: {
          showMsg: false
        }
      }).then(({ data }) => {
        if (this.pageType == 'procure') {
          this.$router.replace({ path: '/procure/edit', query: { ...this.$route.query } })
          return
        }
        if (this.pageType == 'join') {
          this.$router.replace({ path: '/join/edit', query: { ...this.$route.query } })
          return
        }
        if (this.pageType == 'recruit') {
          this.$router.replace({ path: '/recruit/edit', query: { ...this.$route.query } })
          return
        }
        if (this.pageType == 'paper') {
          this.$router.replace({ path: '/paper/edit', query: { ...this.$route.query } })
          return
        }
        if (this.pageType == 'shop') {
          this.$router.back();
        }
        this.playAlery = true;
        this.$store.state.loginStatus = 1;
        this.playAlery = true;
        this.no = data.no;
        this.$store.state.loginInfo.id = data.id;
        localStorage.setItem("loginInfo", JSON.stringify(this.$store.state.loginInfo));
        this.amount = data.total_amount;
      }).catch((data) => {
        this.showDialog({
          showCancelButton: true,
          cancelButtonText: "退出申请",
          confirmButtonText: "重新选择",
          message: data.message,
        }).then(() => {
          this.list = this.list.map(item => ({ ...item, answer: null }));
        }).catch(() => {
          this.$router.back();
          this.$router.go(-1)
        })
      })
    },
  },
  created () {
    let { cate_id } = this.$route.query
    if (cate_id) {
      this.pageType = 'recruit'
    }
    if (this.$route.path.includes('/procure')) {
      this.pageType = 'procure'
    }
    if (this.$route.path.includes('/join')) {
      this.pageType = 'join'
    }
    if (this.$route.path.includes('/paper')) {
      this.pageType = 'paper'
    }
    if (this.$route.path.includes('/shop')) {
      this.pageType = 'shop'
    }
    this.cate_id = cate_id;
    this.ajax({
      url: this.pageType == 'shop' ? 'products/getconcept' : this.pageType == 'procure' ? 'procures/getconcept' : this.pageType == 'recruit' ? 'recruits/getconcept'
        : this.pageType == 'join' ? 'joins/getconcept' : this.pageType == 'paper' ? 'papers/getconcept' : "users/getconcept",
      method: 'post',
      data: {
        cate_id
      },
      myData: {
        showMsg: false
      }
    }).then(({ data }) => {
      console.log(data);
      this.list = data.map(item => ({ ...item, answer: null }));
    })
  },
  computed: {},
  mounted () {
  }
}
</script>

<style lang="scss">
.explain_bottom{
  background-color: #fff;
  bottom: 0;
}
.explain{
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  .explain_item{
    margin: 5px 0;
    margin-right: 5px;
  }
}
</style>
